// in src/users.js
import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import * as React from "react";
import { Fragment, useEffect, useState } from "react";
// import { useRecordContext } from 'react-admin';
import {
  BooleanField,
  BooleanInput,
  BulkDeleteButton,
  BulkUpdateButton, Create, Datagrid, DateField,
  DateInput, Edit, FileField,
  FileInput, Filter, FormTab, List, Loading,
  SimpleForm, TabbedForm, TextField, TextInput, TopToolbar,
  required,
  useNotify, useRedirect, useRefresh
} from "react-admin";
import AddImpiantoButton from "./AddImpiantoButton";
import BulkPremiumButton from "./BulkPremiumButton";
import BulkReportButton from "./BulkReportButton";
import ListActions from "./CustomActionBar";
import DownloadButton from "./DownloadButton";
import httpClient from "./HttpClient";

// const PlantTextField = ({ source }) => {
//     const record = useRecordContext();
//     console.log(record)
//     return (
//         record.impianto_inserito===0 ? <BooleanField source="false" record="false" sortable={false} /> :
//         <BooleanField source="true" record="true" sortable={false} />

//     );
// };

const downloadFile = () => {
  let link = document.createElement("a");
  link.href = "esempio.xlsx";
  link.download = "esempio.xlsx";
  link.click();
};

const trueIcon = () => {
  return <DoneIcon style={{ color: "green" }} />;
};

const falseIcon = () => {
  return <ClearIcon style={{ color: "red" }} />;
};

const PostEditActions = ({ basePath, data, resource }) => (
  <TopToolbar>
    <Button color="primary" onClick={downloadFile}>
      Scarica file di esempio
    </Button>
  </TopToolbar>
);

const UsersBulkActionButtons = (props) => (
  <Fragment>
    <BulkReportButton {...props} />
    <BulkPremiumButton {...props} />
    <BulkUpdateButton
      {...props}
      resource="gse/aggiorna-impianti"
      label="Aggiorna impianti"
    />
    {/* default bulk delete action */}
    <BulkDeleteButton {...props} />
  </Fragment>
);

export const UserList = (props) => (
  <List
    perPage={100}
    filters={<UserFilter />}
    {...props}
    actions={<ListActions />}
    title="Lista utenti"
    bulkActionButtons={<UsersBulkActionButtons />}
  >
    <Datagrid rowClick="edit">
      {/* <TextField source="id" /> */}
      {/* <TextField source="id_gse" /> */}
      <TextField
        source="cliente"
        label="proprietario impianto"
        emptyText="N\A"
      />
      <TextField source="identificativoGse" label="id gse" />
      <TextField source="convenzioneSsp" label="ssp" />
      <DateField
        source="dataContratto"
        label="data stipulazione contratto"
        emptyText="N\A"
      />
      <BooleanField
        source="impiantoInserito"
        label="caricamento in piattaforma"
        TrueIcon={trueIcon}
        FalseIcon={falseIcon}
      />
      <BooleanField
        source="premiumAttivato"
        label="sblocco premium"
        TrueIcon={trueIcon}
        FalseIcon={falseIcon}
      />
      <DownloadButton />
    </Datagrid>
  </List>
);

export const UserSSPList = (props) => (
  <List
    perPage={100}
    filters={<UserFilter />}
    {...props}
    actions={<ListActions />}
    title="Lista utenti"
    bulkActionButtons={<UsersBulkActionButtons />}
  >
    <Datagrid rowClick="edit">
      {/* <TextField source="id" /> */}
      {/* <TextField source="id_gse" /> */}
      <TextField
        source="cliente"
        label="proprietario impianto"
        emptyText="N\A"
      />
      <TextField source="convenzioneSsp" label="ssp" />
      <DateField
        source="dataContratto"
        label="data stipulazione contratto"
        emptyText="N\A"
      />
      <BooleanField
        source="impiantoInserito"
        label="caricamento in piattaforma"
        TrueIcon={trueIcon}
        FalseIcon={falseIcon}
      />
      <BooleanField
        source="premiumAttivato"
        label="sblocco premium"
        TrueIcon={trueIcon}
        FalseIcon={falseIcon}
      />
      <DownloadButton />
    </Datagrid>
  </List>
);

export const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Cerca per cliente" source="proprietario" alwaysOn />
    {/* <ReferenceInput label="User" source="userId" reference="users" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput> */}
  </Filter>
);

export const UserEdit = (props) => (
  <Edit {...props} title="Modifica utente">
    <SimpleForm>
      {/* <ReferenceInput source="userId" reference="users">
                <SelectInput optionText="id" />
            </ReferenceInput> */}
      {/* <TextInput disabled source="id" /> */}
      <TextInput source="cliente" validate={required()} />
      <TextInput source="username" validate={required()} />
      <TextInput source="password" validate={required()} />
      <DateInput source="dataContratto" label="Data contratto"/>
      <TextInput source="identificativoGse" label="Identificativo GSE"/>
      {/* <BooleanInput label="impianto inserito" source="impianto_inserito" /> */}
      <AddImpiantoButton />
      <TextField source="esitoInserimentoImpianto" emptyText="---" />
    </SimpleForm>
  </Edit>
);

export const UserCreate = (props) => {
  const redirect = useRedirect();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [soloSsp, setSoloSsp] = useState(false);
  const delay = 10000;

  useEffect(() => {
    function tick() {
      httpClient(window.BaseURL + `/gse/checkStatus`, {
        method: "GET",
      }).then(({ json }) => {
        console.log(json);
        if (json !== undefined && json.status === 0) {
          setLoading(true);
          let statusMessage = json.msg.replace(/(<([^>]+)>)/gi, "");
          setMessage(statusMessage);
        } else {
          setLoading(false);
        }
      });
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);

  useEffect(() => {
    httpClient(window.BaseURL + `/gse/checkStatus`, {
      method: "GET",
    }).then(({ json }) => {
      if (json !== undefined && json.status === 0) {
        setLoading(true);
        let statusMessage = json.msg.replace(/(<([^>]+)>)/gi, "");
        setMessage(statusMessage);
      }
    });
  }, []);

  const onSuccess = () => {
    redirect("/gse");
    setLoading(false);
    notify(
      `Stiamo recuperando i dati, ciò può richiedere fino a 10 minuti ad impianto`,
      undefined,
      undefined,
      false
    );
    refresh();
  };

  const onError = () => {
    notify(
      `Errore durante l'importazione del file excell`,
      "error",
      undefined,
      false
    );
    refresh();
  };

  return (
    // <Create {...props} actions={<PostEditActions />} onSuccess={onSuccess} onError={onError}>
    <Create {...props} onSuccess={onSuccess} onError={onError}>
      {/* {!loading ? (
        <SimpleForm>
          <FileInput
            source="files"
            label="Carica un file excell con la lista utenti"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      ) : (
        <>
          <div className="container">
            <Loading
              loadingPrimary="In elaborazione"
              loadingSecondary={message}
            />
          </div>
        </>
      )} */}
      {!loading ? (
        <TabbedForm>
          <FormTab label="Inserimento da file">
            <FileInput
              source="files"
              label="Carica un file excel con la lista utenti"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
              <FileField source="src" title="title" />
            </FileInput>
          </FormTab>
          <FormTab label="Inserimento manuale">
            <TextInput source="username" label="User ID" required/>
            <TextInput source="password" required/>
            <TextInput source="identificativoGse" label="Identificativo GSE" disabled={soloSsp}/>
            <TextInput source="convenzioneSsp" label="Identificativo ssp" />
            <TextInput source="cliente"/>
            <DateInput source="dataContratto" label="Data contratto"/>
            <BooleanInput source="soloSsp" label="Impianto solo SSP" defaultValue={false} onChange={e => setSoloSsp(e)}/>
          </FormTab>
        </TabbedForm>
      ) : (
        <>
          {/* <p>Stiamo recuperando i dati, ciò può richiedere fino a 10 minuti ad impianto.</p> */}
          <div className="container">
            <Loading
              loadingPrimary="In elaborazione"
              loadingSecondary={message}
            />
          </div>
        </>
      )}
    </Create>
  );
};
